(() => {
  'use strict';
  const KEY = '__otheriverImpact';
  if (window[KEY]) { window[KEY].refresh(); return; }
  let teardown = () => {}, timer;
  function init(attempt = 0) {
    teardown();
    const root = document.querySelector('[data-oi-root]');
    if (!root) return;
    const object = window.OtheriverImpactObject?.mount(root.querySelector('[data-oi-object]'));
    const gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) {
      teardown = () => object?.destroy();
      if (attempt < 30) timer = setTimeout(() => init(attempt + 1), 100);
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    const mm = gsap.matchMedia();
    const work = root.querySelector('.oi-work');
    const stage = root.querySelector('.oi-work-stage');
    const track = root.querySelector('.oi-work-track');
    const projects = [...root.querySelectorAll('.oi-project')];
    let workTimeline;
    let viewportFrame;
    const viewport = window.visualViewport;
    const updateViewport = () => {
      root.style.setProperty('--oi-viewport-height', `${Math.round(viewport?.height || window.innerHeight)}px`);
    };
    const headerHeight = () => {
      const group = document.querySelector('#header-group');
      if (group && ['sticky', 'fixed'].includes(getComputedStyle(group).position)) return group.getBoundingClientRect().height;
      const header = document.querySelector('.otheriver-site-header');
      return header && ['sticky', 'fixed'].includes(getComputedStyle(header).position) ? header.getBoundingClientRect().height : 0;
    };
    const updateHeader = () => root.style.setProperty('--oi-header', `${headerHeight()}px`);
    updateHeader();
    updateViewport();
    const ctx = gsap.context(() => {
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        gsap.from('.oi-line>span', {yPercent: 115, rotate: 3, duration: 1.1, stagger: .12, ease: 'power4.out', clearProps: 'transform'});
        gsap.from('.oi-hero-top,.oi-hero-bottom', {y: 16, opacity: 0, duration: .8, delay: .3, stagger: .12, clearProps: 'all'});
        gsap.from('.oi-hero-rule', {scaleX: 0, duration: 1.3, ease: 'power3.out'});
        gsap.to('.oi-object', {yPercent: 18, rotate: 16, ease: 'none', scrollTrigger: {trigger: '.oi-hero', start: 'top top', end: 'bottom top', scrub: .6}});
        gsap.to('.oi-hero-title', {yPercent: -13, ease: 'none', scrollTrigger: {trigger: '.oi-hero', start: 'top top', end: 'bottom top', scrub: .6}});
        const manifesto = root.querySelector('.oi-manifesto');
        const words = manifesto.textContent.trim().split(/\s+/);
        const original = manifesto.textContent;
        manifesto.textContent = '';
        for (let i = 0; i < words.length; i++) {
          const word = document.createElement('span');
          word.className = 'oi-manifesto-word'; word.textContent = words[i]; manifesto.append(word);
          if (i < words.length - 1) manifesto.append(document.createTextNode(' '));
        }
        gsap.from('.oi-manifesto-word', {opacity: .2, stagger: .12, ease: 'none', scrollTrigger: {trigger: manifesto, start: 'top 85%', end: 'bottom 52%', scrub: .3}});
        gsap.from('.oi-service', {y: 35, opacity: 0, stagger: .1, duration: .7, ease: 'power3.out', scrollTrigger: {trigger: '.oi-services', start: 'top 88%', once: true}, clearProps: 'transform,opacity'});
        gsap.from('.oi-apps-heading h2>span', {xPercent: (i) => i ? 15 : -15, opacity: .4, stagger: .1, scrollTrigger: {trigger: '.oi-apps', start: 'top 85%', end: 'top 30%', scrub: .6}});
        gsap.fromTo('.oi-app--groupify', {rotate: -10, y: 80}, {rotate: -2, y: 0, ease: 'none', scrollTrigger: {trigger: '.oi-apps-deck', start: 'top 95%', end: 'bottom 55%', scrub: .6}});
        gsap.fromTo('.oi-app--portal', {rotate: 12, y: 140}, {rotate: 2, y: 30, ease: 'none', scrollTrigger: {trigger: '.oi-apps-deck', start: 'top 95%', end: 'bottom 55%', scrub: .6}});
        gsap.from('.oi-contact h2', {y: 90, rotate: -3, opacity: .2, ease: 'power2.out', scrollTrigger: {trigger: '.oi-contact', start: 'top 90%', end: 'top 35%', scrub: .5}});
        return () => { manifesto.textContent = original; };
      });
      mm.add({motion: '(prefers-reduced-motion: no-preference)', wide: '(min-width: 768px)', short: '(max-height: 599px)'}, media => {
        if (!media.conditions.motion || !projects.length) return;
        const compact = !media.conditions.wide || media.conditions.short;
        work.classList.add('is-pinned');
        updateHeader();
        gsap.set(projects[0], {scale: compact ? .54 : .43, rotation: -8, xPercent: compact ? 0 : 12, yPercent: compact ? 19 : 14});
        gsap.set(projects[0].querySelector('.oi-project-info'), {opacity: 0});
        const projectStops = [1.15];
        workTimeline = gsap.timeline({defaults: {ease: 'none'}, scrollTrigger: {
          trigger: work, pin: stage, start: () => `top top+=${headerHeight()}`,
          end: () => `+=${Math.max(1600, stage.clientHeight * (projects.length + 1))}`, scrub: compact ? .45 : .7,
          invalidateOnRefresh: true, anticipatePin: 1, onRefreshInit: updateHeader
        }});
        workTimeline
          .to('.oi-work-intro', {yPercent: -30, opacity: 0, duration: .75}, 0)
          .to('.oi-stack img', {xPercent: (i) => i ? 55 : -50, rotation: (i) => i ? 20 : -20, opacity: 0, duration: .7, stagger: .05}, 0)
          .to(projects[0], {scale: 1, rotation: 0, xPercent: 0, yPercent: 0, duration: 1.05, ease: 'power2.inOut'}, 0)
          .to(projects[0].querySelector('.oi-project-info'), {opacity: 1, duration: .3}, .65);
        projects.slice(1).forEach((project, offset) => {
          const index = offset + 1;
          const start = 1.5 + offset * 1.45;
          workTimeline
            .to(track, {x: () => -stage.clientWidth * index, duration: .95, ease: 'power2.inOut'}, start)
            .from(project.querySelector('h3'), {x: compact ? 35 : 100, duration: .75}, start + .25);
          projectStops.push(start + 1.1);
        });
        const finalTime = projectStops[projectStops.length - 1] + .3;
        workTimeline.to({}, {duration: .45}, finalTime - .45)
          .to('.oi-work-progress span', {scaleX: 1, duration: finalTime}, 0);
        const onFocus = event => {
          const index = projects.findIndex(project => project.contains(event.target));
          if (index < 0 || !workTimeline?.scrollTrigger) return;
          const st = workTimeline.scrollTrigger;
          const targetTime = projectStops[index];
          const targetScroll = st.start + (st.end - st.start) * targetTime / workTimeline.duration();
          if (Math.abs(scrollY - targetScroll) > 80) {
            window.scrollTo({top: targetScroll, behavior: 'instant'});
            // Synchronize the pin and its scrubbed animation for keyboard focus.
            ScrollTrigger.update();
            st.getTween()?.progress(1);
          }
        };
        track.addEventListener('focusin', onFocus);
        return () => { track.removeEventListener('focusin', onFocus); work.classList.remove('is-pinned'); workTimeline = null; };
      });
    }, root);
    const workLink = root.querySelector('.oi-scroll-link');
    const onWork = event => {
      if (!workTimeline?.scrollTrigger) return;
      event.preventDefault();
      const st = workTimeline.scrollTrigger;
      window.scrollTo({top: st.start, behavior: 'smooth'});
      history.replaceState(null, '', '#oi-work');
      root.querySelector('#oi-work-title').focus({preventScroll: true});
    };
    workLink.addEventListener('click', onWork);
    let active = true;
    const refresh = () => {
      if (!active) return;
      updateHeader();
      updateViewport();
      ScrollTrigger.refresh();
    };
    const onViewportResize = () => {
      cancelAnimationFrame(viewportFrame);
      viewportFrame = requestAnimationFrame(refresh);
    };
    viewport?.addEventListener('resize', onViewportResize);
    document.fonts?.ready.then(refresh);
    const images = [...root.querySelectorAll('img')];
    images.filter(img => !img.complete).forEach(img => img.addEventListener('load', refresh, {once: true}));
    teardown = () => {
      active = false; clearTimeout(timer);
      cancelAnimationFrame(viewportFrame);
      workLink.removeEventListener('click', onWork);
      images.forEach(img => img.removeEventListener('load', refresh));
      viewport?.removeEventListener('resize', onViewportResize);
      mm.revert(); ctx.revert(); object?.destroy(); work.classList.remove('is-pinned'); root.style.removeProperty('--oi-header'); root.style.removeProperty('--oi-viewport-height');
    };
  }
  window[KEY] = {refresh: () => init(), destroy: () => teardown()};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true}); else init();
  document.addEventListener('shopify:section:load', () => init());
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-oi-root]')) teardown(); });
})();
